import * as React from 'react';
import styled from 'styled-components';
import { TabsProvider } from './TabsContext';
import TabList from './TabList';
import TabPanels from './TabPanels';

const StyledTabs = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

const Tabs = () => (
    <TabsProvider>
        <StyledTabs data-testid="price-tiers-tabs">
            <TabList />
            <TabPanels />
        </StyledTabs>
    </TabsProvider>
);

export default Tabs;
